import { ConvexReactClient } from "convex/react";
import { anyApi } from "convex/server";

const CONVEX_URL = "https://bold-pony-700.eu-west-1.convex.cloud";

let client: ConvexReactClient | null = null;

export function getConvexClient(): ConvexReactClient {
  if (!client) {
    client = new ConvexReactClient(CONVEX_URL);
  }
  return client;
}

export const api = anyApi;

/** Drammen Car Wash i Ascendly. Sto tidligere i tre ruter hver for seg. */
export const BUSINESS_ID = "jh77w8p1ewdwak4qqg7k8fjben8b8zn5";
